import React, { useState } from 'react';
import {AppContext} from "./Contexts/AppContext";
import List from "./Components/List";
import Poi from "./Components/Poi";
import './App.css';
import {Navigate, Route, Routes} from "react-router-dom";

function App() {
    const [activeGroups, setActiveGroups] = useState([]);

    return (
        <AppContext.Provider value={{activeGroups, setActiveGroups}}>
            <Routes>
                <Route path="/poi/:id" element={<Poi/>}/>
                <Route path="/" element={<List/>}/>
                <Route path='*' element={<Navigate to='/' />} />
            </Routes>
        </AppContext.Provider>
    )
}

export default App;
